import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import { regions } from "../../mock";

const Marquee = ({ items, reverse }) => (
  <div className="overflow-hidden py-2">
    <div className="marquee-track" style={reverse ? { animationDirection: "reverse" } : {}}>
      {[...items, ...items].map((name, i) => (
        <span key={i} className="flex-shrink-0 mx-8 md:mx-12 font-serif-display text-2xl md:text-4xl text-white/45 whitespace-nowrap">
          {name}
        </span>
      ))}
    </div>
  </div>
);

const Developers = () => {
  return (
    <section id="developers" className="relative overflow-hidden bg-[#111113] text-white py-24 md:py-32">
      <img
        src="https://images.unsplash.com/photo-1638284457192-27d3d0ec51aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
        alt="Developers"
        className="absolute inset-0 w-full h-full object-cover opacity-15"
      />
      <div className="relative max-w-[1100px] mx-auto px-6 md:px-10 text-center reveal">
        <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-6">Developers</p>
        <h2 className="font-serif-display text-4xl md:text-6xl font-light leading-tight max-w-4xl mx-auto">
          We work with the best builders in Washington DC &amp; Northern VA
        </h2>
        <div className="w-40 h-px bg-[#b4936a] mx-auto my-10" />
        <p className="text-white/60 text-[15px] leading-relaxed max-w-2xl mx-auto">
          Capital Corner Group is the in-house sales partner developers trust when it matters most &mdash; from ground-up estates to landmark restorations. We deliver record prices and record pace on the region&rsquo;s most ambitious projects.
        </p>
      </div>

      <div className="relative mt-16 space-y-3">
        <Marquee items={regions} />
        <Marquee items={regions.slice().reverse()} reverse />
      </div>

      <div className="relative text-center mt-14 reveal">
        <Link to="/developers" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-white border border-white/40 px-8 py-4 hover:bg-white hover:text-black transition-colors">
          Explore Developer Partnerships <ArrowRight size={14} />
        </Link>
      </div>
    </section>
  );
};

export default Developers;
